module.exports = __webpack_public_path__ + "static/media/lineCardprev.0e2a377c.png";